import { inject, Injectable, signal } from "@angular/core";
import { IConfiguration, IFEConfigResultData } from "./model/pos.api.model";
import { LoginService } from "./login.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs";

// For testing purposes only
export interface Trip {
  id: string;
}

@Injectable({
  providedIn: "root",
})
export class StateService {
  waitingTrip = signal<Trip | null>(null);
  waitingTripId = signal<string | null>(null);

  waitingTripReturn = signal<Trip | null>(null);
  waitingTripReturnId = signal<string | null>(null);

  pageNameOverride = signal<string | null>(null);

  loginService = inject(LoginService);

  currencyCode = toSignal(
        this.loginService.loginChanged.pipe(
          map(user => user?.CurrencyCode ?? ''),
        ),
        { initialValue: '' },
      );

  // Will be connected in ticket DEV-10531
  configuration: IConfiguration | null = {
    maxCardPaymentPercentage: 100,
    maxCardPaymentValue: 999999,
    maxBenefitPaymentValue: 999,
    maxBenefitPaymentPercentage: 1,
    maxCashPaymentPercentage: 100,
    maxCashPaymentValue: 999999,
    maxVoucherBenefitPrice: 999999,
    maxVoucherCardPrice: 999999,
    maxVoucherCashPrice: 999999,
    crossSaleMarketCodes: [],
  };

  constructor() {
    const config = localStorage.getItem("configuration");
    if (config) {
      this.configuration = JSON.parse(config);
    }
  }

  get helpLink(): string | null {
    return this.configuration?.helpLink || null;
  }

  setConfig(config: IFEConfigResultData): void {
    this.configuration = {
      notificationRefreshMinutes: config.NotificationRefreshMinutes,
      notificationPageSize: config.NotificationPageSize,
      helpLink: config.HelpLink,
      maxCardPaymentPercentage: config.MaxCardPercentage,
      maxCardPaymentValue: config.MaxCardValue,
      maxBenefitPaymentValue: config.MaxBenefitValue,
      maxBenefitPaymentPercentage: config.MaxBenefitPercentage,
      maxCashPaymentPercentage: config.MaxCashPercentage,
      maxCashPaymentValue: config.MaxCashValue,
      maxVoucherBenefitPrice: config.MaxVoucherBenefitPrice,
      maxVoucherCardPrice: config.MaxVoucherCardPrice,
      maxVoucherCashPrice: config.MaxVoucherCashPrice,
      crossSaleMarketCodes: config.CrossSaleMarketCodes ?? [],
      flightTicketVariableSymbolRegex: config.FlightTicketVariableSymbolRegex,
      eTravelVariableSymbolRegex: config.ETravelVariableSymbolRegex,
      bnrRegex: config.BnrRegex,
    };

    localStorage.setItem("configuration", JSON.stringify(this.configuration));
  }
}
